/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const LIST_CUSTOM_MAP_POINTS = gql`
  query GetCustomMapPoint {
    allSalesPoints {
      id
      coordinate
      isDisabled
      pointCategorization {
        id
        name
        type1
      }
    }
  }
`;

export const LIST_DISTRIBUTION_COUNTS = gql`
  query GetAllDistrinutionCounts {
    allDistributionCounts {
      id
      suburbName
      total
      publication {
        id
        name
      }
    }
  }
`;

export const LIST_FOOTPRINT_FILTERS = gql`
  query GetFootprintFilters {
    publicationMapResults {
      id
      province
      newspaper
    }
  }
`;

export const LIST_ALL_PUBLICATIONS = gql`
  query GetAllPublications {
    allPublications {
      id
      name
      isDisabled
    }
  }
`;

export const LIST_POINT_DETAILS_BY_ID = gql`
  query GetPointDetailsById($id: Int!) {
    salesPointById(id: $id) {
      id
      name
      address
      coordinate
      pointCategorization {
        id
      }
      additionalInformation
      approvalStatus
      isDisabled
      contactName
      contactNumber
      emailAddress
      websiteAddress
    }
  }
`;

export const LIST_SALES_POINTS = gql`
  query GetAllSalesPoints {
    allSalesPoints {
      id
      name
      address
      approvalStatus
      isDisabled
      pointCategorization {
        name
        type1
        type2
        type3
      }
    }
  }
`;

export const LIST_SALES_POINTS_DATA = gql`
  query GetAllSalesPoints {
    allSalesPoints {
      id
      name
      address
      additionalInformation
      approvalStatus
      contactName
      contactNumber
      coordinate
      emailAddress
      isDisabled
      pointCategorization {
        name
        type1
        type2
        type3
      }
      websiteAddress
    }
  }
`;

export const GET_AG_POINTS_OF_INTEREST = gql`
  query GetAgPointsOfInterest($input: CustomerPointReportInput!) {
    customerPoints(input: $input) {
      pointsOfInterest {
        id
        address
        category
        contactName
        contactNumber
        coordinate
        emailAddress
        websiteAddress
        name
        type1
        type2
        type3
      }
    }
  }
`;

export const GET_AG_POINTS_TRAVEL_BANDS = gql`
  query GetAgPointsOfInterest($input: CustomerPointReportInput!) {
    customerPoints(input: $input) {
      pointsOfInterest {
        id
        address
        category
        contactName
        contactNumber
        coordinate
        emailAddress
        websiteAddress
        name
        type1
        type2
        type3
      }
      travelBand {
        coordinates
        type
        bbox
        crs
      }
    }
  }
`;

export const GET_COMPETITOR_POINTS = gql`
  query GetCompetitorPoints($input: CustomerPointReportInput!) {
    customerPoints(input: $input) {
      customerPoints {
        id
        address
        category
        contactName
        contactNumber
        coordinate
        emailAddress
        websiteAddress
        name
        type1
        type2
        type3
      }
    }
  }
`;

export const GET_COMPETITOR_TRAVEL_BANDS = gql`
  query GetCompetitorTravelBands($input: CustomerPointReportInput!) {
    customerPoints(input: $input) {
      customerPoints {
        id
        address
        category
        contactName
        contactNumber
        coordinate
        emailAddress
        websiteAddress
        name
        type1
        type2
        type3
      }
      travelBand {
        coordinates
        type
        bbox
        crs
      }
    }
  }
`;

export const GET_DISTRIBUTION_COUNT_DETAILS_BY_ID = gql`
  query GetDistributionCountsById($id: Int!) {
    distributionCountById(id: $id) {
      id
      suburbId
      suburbName
      total
      publicationId
    }
  }
`;

export const GET_FOOTPRINT_PAPERCOUNT = gql`
  query GetFootprintPAPERCOUNT($latitude: Float!, $longitude: Float!) {
    publicationFootprintReportsData(latitude: $latitude, longitude: $longitude) {
      id
      name
      numberOfPapers
    }
  }
`;

export const GET_POINT_FOOTPRINT_DATA = gql`
  query GetPointFootprintData($latitude: Float!, $longitude: Float!) {
    publicationFootprintReportsData(latitude: $latitude, longitude: $longitude) {
      id
      name
      colour
      geometry
    }
  }
`;

export const GET_POINT_CATEGORIZATIONS = gql`
  query GetAllPointCategorizations {
    allPointCategorizations {
      id
      name
      type1
      type2
      type3
      isDisabled
    }
  }
`;

export const GET_AFRIGIS_POINT_CATEGORIZATIONS = gql`
  query GetAllAfrigisPointCategorizations {
    allAfrigisPointCategorizations {
      category
      type1
      type2
      type3
    }
  }
`;

export const GET_SALES_POINT_DETAILS = gql`
  query GetPointDetailsById($id: Int!) {
    salesPointById(id: $id) {
      id
      address
      name
      coordinate
      contactName
      contactNumber
      emailAddress
      websiteAddress
      pointCategorization {
        id
        name
        type1
        type2
        type3
      }
      additionalInformation
      approvalStatus
      isDisabled
    }
  }
`;

export const GET_SUBURB_DATA = gql`
  query GetSuburbData($latitude: Float!, $longitude: Float!) {
    publicationFootprintReportsData(latitude: $latitude, longitude: $longitude) {
      id
      name
      suburbsData {
        sublocalityName
        total
        townName
      }
    }
  }
`;
